module.exports = __webpack_public_path__ + "1e71cf3cf3ca22c4e4e1489e2133b07c.fbx";